export const USER_PROJECT_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
}

export const ALL_STATUSES_USER = [
  USER_PROJECT_STATUS.INACTIVE,
  USER_PROJECT_STATUS.ACTIVE,
]

export const UNKNOWN_USER_NAME = 'Пользователь не найден'
